import React, { useEffect, useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import "../styles/AutoPopupForm.css";

const AutoPopupForm = () => {
  const formRef = useRef();
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  /* -------------------------
     Show popup automatically
  --------------------------*/
  useEffect(() => {
    const alreadyShown = sessionStorage.getItem("popupShown");
    if (alreadyShown) return;

    // Show after 6 sec
    const timer = setTimeout(() => {
      setShow(true);
      sessionStorage.setItem("popupShown", "true");
    }, 6000);

    return () => clearTimeout(timer);
  }, []);

  /* -------------------------
     EmailJS init
  --------------------------*/
  emailjs.init("YWyfWV3Y-YTiC109P");

  // Custom alert (styled via CSS - same as Contactus.js)
  const showAlert = (type, message) => {
    const alertBox = document.createElement("div");
    alertBox.className = `custom-alert ${type}`;
    alertBox.innerHTML = `
      <span class="alert-icon">${type === "success" ? "✅" : "❌"}</span>
      <span class="alert-text">${message}</span>
    `;
    document.body.appendChild(alertBox);

    setTimeout(() => {
      alertBox.remove();
    }, 4500);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    emailjs
      .sendForm("service_jlh6tvr", "template_20mxpjm", formRef.current)
      .then(() => {
        showAlert(
          "success",
          "Message sent successfully! We'll contact you shortly."
        );
        formRef.current.reset();
        setShow(false);
        setLoading(false);
      })
      .catch(() => {
        showAlert(
          "error",
          "Failed to send message. Please try again later."
        );
        setLoading(false);
      });
  };

  if (!show) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-box">

        {/* Close button */}
        <button className="popup-close" onClick={() => setShow(false)}>✕</button>

        <h2>Let’s Grow Your Business </h2>
        <p>Talk with our experts today</p>

        <form ref={formRef} onSubmit={handleSubmit}>

          <input name="name" placeholder="Your Name *" required />
          <input name="email" type="email" placeholder="Email *" required />
          <input name="phone" placeholder="Phone *" required />

          <select name="service" required>
            <option value="">Select Service</option>
            <option>SEO</option>
            <option>Digital Marketing</option>
            <option>Web Development</option>
            <option>Content Marketing</option>
          </select>

          <textarea name="message" placeholder="Your Message" required />

          <button type="submit" disabled={loading}>
            {loading ? "Sending..." : "Get Free Consultation"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AutoPopupForm;
